export interface IPopularWidget {
	name: string;
	slug: string;
	category: string;
	logo: string;
}

// Curated list of top widgets shown on the homepage showcase grid.
// Slugs and logos must match entries in apps.json — they map to /widgets/<slug> pages.
const CDN = 'https://website-assets.commoninja.com';

export const popularWidgets: IPopularWidget[] = [
	{
		name: 'WhatsApp Button',
		slug: 'whatsapp-button',
		category: 'Chat',
		logo: `${CDN}/images/1664692535139_whatsapp-icon.webp`,
	},
	{
		name: 'Google Reviews',
		slug: 'google-reviews',
		category: 'Reviews',
		logo: `${CDN}/images/1670416918559_Google-reviews-icon.webp`,
	},
	{
		name: 'Instagram Feed',
		slug: 'instagram-feed',
		category: 'Social Feeds',
		logo: `${CDN}/images/1674037954744_instagram-feeds-icon.webp`,
	},
	{
		name: 'AI Chatbot',
		slug: 'ai-chatbot',
		category: 'Chat',
		logo: `${CDN}/distribution/ai-chat-icon.webp`,
	},
	{
		name: 'Form Builder',
		slug: 'form-builder',
		category: 'Forms',
		logo: `${CDN}/images/1679480335296_form-builder-icon.webp`,
	},
	{
		name: 'Countdown Timer',
		slug: 'countdown',
		category: 'Countdown Timers',
		logo: `${CDN}/images/1681118357912_countdown-icon.webp`,
	},
	{
		name: 'Popup Builder',
		slug: 'popup-builder',
		category: 'Popups',
		logo: `${CDN}/images/1688972714262_popup-builder-icon.webp`,
	},
	{
		name: 'Appointment Booking',
		slug: 'booking',
		category: 'Booking & Events',
		logo: `${CDN}/images/1707056939648_booking-icon.webp`,
	},
	{
		name: 'Pricing Tables',
		slug: 'pricing-tables',
		category: 'E-Commerce',
		logo: `${CDN}/images/1664691627600_pricing-table-icon.webp`,
	},
	{
		name: 'FAQ',
		slug: 'faq',
		category: 'Content',
		logo: `${CDN}/images/1664692271286_faq-icon.webp`,
	},
	{
		name: 'YouTube Feed',
		slug: 'youtube-feed',
		category: 'Social Feeds',
		logo: `${CDN}/images/1666167523958_Youtube-feeds.webp`,
	},
	{
		name: 'Testimonials Slider',
		slug: 'testimonials',
		category: 'Reviews',
		logo: `${CDN}/images/1664691826177_testimonials-icon.webp`,
	},
	{
		name: 'Audio Player',
		slug: 'audio-player',
		category: 'Media',
		logo: `${CDN}/images/1664692226411_audio-player-icon.webp`,
	},
	{
		name: 'Image Carousel',
		slug: 'image-carousel',
		category: 'Media',
		logo: `${CDN}/images/1674567586135_image-carousel-icon.webp`,
	},
	{
		name: 'Events Calendar',
		slug: 'calendar',
		category: 'Booking & Events',
		logo: `${CDN}/images/1684755882469_calendar-icon.webp`,
	},
];
